import {
  Button,
  Flex,
  Heading,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import {
  useCareGroupsPostMutation,
  useCareGroupsPutMutation,
} from "./api/useCareGroupsMutation";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export default function CareGroupAddPage() {
  const { control, handleSubmit, reset } = useForm();
  const { mutate: careGroupsPostMutation } = useCareGroupsPostMutation();
  const navigate = useNavigate();
  const onSubmit = (values) => {
    careGroupsPostMutation(values);
    reset();
    navigate('/user/hr/care-groups');
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Flex
        direction="column"
        minWidth={650}
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(250,250,250,1)"
      >
        <Heading level="1" children="Add Care Groups"></Heading>
        <Flex direction="column" alignItems="flex-start">
          <Controller
            name="groupName"
            control={control}
            render={({ field }) => (
              <TextField
                isRequired={true}
                minWidth="300px"
                label="*Care Group Name"
                {...field}
              />
            )}
          />
          <Controller
            name="groupDescription"
            control={control}
            render={({ field }) => (
              <TextAreaField
                minWidth="300px"
                label="Care Group Description"
                {...field}
              />
            )}
          />
        </Flex>
        <Flex gap="18px" direction="column" alignItems="flex-start">
          <Button variation="primary" children="Save" type="submit" />
        </Flex>
      </Flex>
    </form>
  );
}
